import React, { useState } from 'react';
import { smsService } from '../utils/smsService';

const SMSTest = () => {
  const [phoneNumber, setPhoneNumber] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('custom');
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSendSMS = async () => {
    if (!phoneNumber || !message) {
      setResult('Please enter both phone number and message');
      return;
    }

    setLoading(true);
    setResult('');

    try {
      let smsResult;
      
      switch (messageType) {
        case 'welcome':
          smsResult = await smsService.sendWelcomeMessage(phoneNumber, 'Test User');
          break;
        case 'match':
          smsResult = await smsService.sendMatchNotification(phoneNumber, 'Sarah Johnson');
          break;
        case 'meet':
          smsResult = await smsService.sendMeetReminder(phoneNumber, 'Coffee Meet', '2:00 PM');
          break;
        case 'verification':
          smsResult = await smsService.sendVerificationCode(phoneNumber, '123456');
          break;
        case 'custom':
        default:
          smsResult = await smsService.sendSMS(phoneNumber, message);
          break;
      }

      if (smsResult.success) {
        setResult(`✅ SMS sent successfully! Message ID: ${smsResult.messageId}`);
      } else {
        setResult(`❌ SMS failed: ${smsResult.error}`);
      }
    } catch (error) {
      setResult(`❌ Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const handleMessageTypeChange = (type) => {
    setMessageType(type);
    switch (type) {
      case 'welcome':
        setMessage('Welcome to GradedWash! Start your journey by taking our personality quiz.');
        break;
      case 'match':
        setMessage('You have a new travel match! Check your app now.');
        break;
      case 'meet':
        setMessage('Reminder: Your meet is in 1 hour. See you there!');
        break;
      case 'verification':
        setMessage('Your verification code is: 123456');
        break;
      default:
        setMessage('');
    }
  };

  return (
    <div style={{
      maxWidth: '600px',
      margin: '50px auto',
      padding: '30px',
      backgroundColor: '#fff',
      borderRadius: '12px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Inter, sans-serif'
    }}>
      <h1 style={{
        fontSize: '28px',
        fontWeight: '700',
        color: '#1f2937',
        marginBottom: '8px',
        textAlign: 'center'
      }}>
        SMS Testing Tool
      </h1>
      
      <p style={{
        fontSize: '16px',
        color: '#6b7280',
        marginBottom: '30px',
        textAlign: 'center'
      }}>
        Test SMS functionality for GradedWash
      </p>

      <div style={{ marginBottom: '24px' }}>
        <label style={{
          display: 'block',
          fontSize: '14px',
          fontWeight: '600',
          color: '#374151',
          marginBottom: '8px'
        }}>
          Phone Number:
        </label>
        <input
          type="tel"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          placeholder="+1234567890"
          style={{
            width: '100%',
            padding: '12px 16px',
            border: '2px solid #d1d5db',
            borderRadius: '8px',
            fontSize: '16px',
            outline: 'none',
            transition: 'border-color 0.2s'
          }}
          onFocus={(e) => e.target.style.borderColor = '#2563eb'}
          onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
        />
      </div>

      <div style={{ marginBottom: '24px' }}>
        <label style={{
          display: 'block',
          fontSize: '14px',
          fontWeight: '600',
          color: '#374151',
          marginBottom: '8px'
        }}>
          Message Type:
        </label>
        <select
          value={messageType}
          onChange={(e) => handleMessageTypeChange(e.target.value)}
          style={{
            width: '100%',
            padding: '12px 16px',
            border: '2px solid #d1d5db',
            borderRadius: '8px',
            fontSize: '16px',
            outline: 'none',
            backgroundColor: '#fff',
            cursor: 'pointer'
          }}
        >
          <option value="custom">Custom Message</option>
          <option value="welcome">Welcome Message</option>
          <option value="match">Match Notification</option>
          <option value="meet">Meet Reminder</option>
          <option value="verification">Verification Code</option>
        </select>
      </div>

      <div style={{ marginBottom: '24px' }}>
        <label style={{
          display: 'block',
          fontSize: '14px',
          fontWeight: '600',
          color: '#374151',
          marginBottom: '8px'
        }}>
          Message:
        </label>
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          placeholder="Enter your message here..."
          rows="4"
          style={{
            width: '100%',
            padding: '12px 16px',
            border: '2px solid #d1d5db',
            borderRadius: '8px',
            fontSize: '16px',
            outline: 'none',
            resize: 'vertical',
            fontFamily: 'inherit',
            transition: 'border-color 0.2s'
          }}
          onFocus={(e) => e.target.style.borderColor = '#2563eb'}
          onBlur={(e) => e.target.style.borderColor = '#d1d5db'}
        />
      </div>

      <button
        onClick={handleSendSMS}
        disabled={loading || !phoneNumber || !message}
        style={{
          width: '100%',
          padding: '14px 24px',
          backgroundColor: loading || !phoneNumber || !message ? '#9ca3af' : '#2563eb',
          color: '#fff',
          border: 'none',
          borderRadius: '8px',
          fontSize: '16px',
          fontWeight: '600',
          cursor: loading || !phoneNumber || !message ? 'not-allowed' : 'pointer',
          transition: 'background-color 0.2s',
          marginBottom: '24px'
        }}
      >
        {loading ? 'Sending...' : 'Send SMS'}
      </button>

      {result && (
        <div style={{
          padding: '16px',
          borderRadius: '8px',
          backgroundColor: result.includes('✅') ? '#d1fae5' : '#fee2e2',
          border: `1px solid ${result.includes('✅') ? '#10b981' : '#ef4444'}`,
          color: result.includes('✅') ? '#065f46' : '#991b1b',
          fontSize: '14px',
          lineHeight: '1.5'
        }}>
          {result}
        </div>
      )}

      <div style={{
        marginTop: '24px',
        padding: '16px',
        backgroundColor: '#f3f4f6',
        borderRadius: '8px',
        fontSize: '14px',
        color: '#6b7280'
      }}>
        <strong>Note:</strong> This tool is for testing SMS functionality. 
        Make sure your AWS SNS is properly configured in your .env file.
      </div>
    </div>
  );
};

export default SMSTest; 